import React from "react";
import { Box, Stack } from "@mui/material";
import Header from "./components/Header";
import Details from "./components/Details";
import Bottom from "./components/Bottom";

const heights = {
  header: "50px",
  bottom: "60px",
};

function Right() {
  return (
    <Stack
      gap={1}
      sx={{
        height: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <Header height={heights.header} />
      <Box
        sx={{
          width: "100%",
          height: `calc(100vh - ${heights.header} - ${heights.bottom} - 24px)`,
          pr: 1,
        }}
      >
        <Details />
      </Box>
      <Box sx={{ pr: 1 }}>
        <Bottom height={heights.bottom} />
      </Box>
    </Stack>
  );
}

export default Right;
